<span [formGroup]="form">
<input
	(click)="updateModel(value)"
	[value]="value" type="radio"
	[name]="name"
	[id]="id"
	[required]="required"
	[checked]="model == value"
	[class]="class"
	[formControlName]="name"
	[attr.aria-controls]="ariaControls"
	[attr.aria-describedby]="ariaDescribedBy"
>
<label class="radio" [for]="id" [title]="labelTitle">
    <span *ngIf="hasRecommendation" class="recommendation">{{ recommendationLabel | translate }}</span>
    <i [class]="icon" *ngIf="icon"></i><payment-icons *ngIf="svgIcon" [icon]="svgIcon"></payment-icons><span [innerHTML]="label"></span>
</label>
</span>
